import ETRApi from '../../../core/src/etr-wcs-api-client';
import { Helpers } from '../../../core/src/helpers';
import {
    getPicks,
    getRecommendedConfig,
    selectRecommendedConfig,
    verifyPicks,
    getRecommendedConfigList,
} from '../../util';

import { ADD_CTO_TO_CART } from '../../../metrics/track-params';
import { REFRESH_CART } from '../../../utility/utility-actions';

export const addPreConfigToCart = (configCatentryId, baseConfig, shipDate, history) => {
    const configSlice = JSON.parse(JSON.stringify(baseConfig));
    const { specCategories, recommendedConfigs } = configSlice;
    selectRecommendedConfig(specCategories, recommendedConfigs, configCatentryId);
    return addToCart(configSlice, shipDate).then(() => {});
};

/***
 * Get the add too cart parameters needed for all pre config add to carts
 */
export const buildPreConfigAddToCarts = baseConfig => {
    const { recommendedConfigs } = baseConfig || {};
    const configList = getRecommendedConfigList(recommendedConfigs);
    if (!configList || configList.length < 1) {
        reject('Base config contains no recommended configs');
    }
    //verify recommended configs sequentially. For some reason doing them in parallel caused some weird results
    return configList
        .reduce((r, p) => {
            const { configCatentryId } = p;
            return r.then(result => {
                return verifyPDK(configCatentryId, baseConfig).then(resp => {
                    return result.concat([resp]);
                });
            });
        }, Promise.resolve([]))
        .then(resp => {
            return resp.reduce((r, p) => {
                if (!p) {
                    return r;
                }
                r[p.configCatentryId] = p;
                return r;
            }, {});
        });
    /* return Promise.all(
        configList.map(({ configCatentryId }) => {
            if (configCatentryId !== '3074457345620122819') {
                return null;
            }
            return verifyPDK(configCatentryId, baseConfig);
        })
    ).then(resp => {
        return resp.reduce((r, p) => {
            if (!p) {
                return r;
            }
            r[p.configCatentryId] = p;
            return r;
        }, {});
    });*/
};

const verifyPDK = (configCatentryId, baseConfig) => {
    return new Promise((resolve, reject) => {
        let response = { configCatentryId };
        const configSlice = JSON.parse(JSON.stringify(baseConfig));
        const { specCategories, recommendedConfigs } = configSlice;
        selectRecommendedConfig(specCategories, recommendedConfigs, configCatentryId);
        verifyPicks({ baseConfig: configSlice }, resp => {
            const { baseConfig, shipDate, errors } = resp;
            if (baseConfig) {
                response.baseConfig = baseConfig;
            }
            if (shipDate) {
                response.shipDate = shipDate;
                response.errors = errors;
                resolve(response);
            }
        });
    });
};

const getOrderItemId = addtocartconfig => {
    try {
        const { orderItemId } = addtocartconfig;
        const validTypes = ['string', 'number'];
        return Array.isArray(orderItemId) && orderItemId.length === 1 && validTypes.includes(typeof orderItemId[0])
            ? orderItemId[0] + ''
            : validTypes.includes(typeof orderItemId)
              ? orderItemId + ''
              : null;
    } catch (e) {}
};

const conditionallyTrackCtoAddToCart = (trackCustomMetric, addtocartconfig, quantityChange) => {
    try {
        let orderItemId = getOrderItemId(addtocartconfig);
        typeof trackCustomMetric === 'function' &&
            orderItemId &&
            trackCustomMetric(ADD_CTO_TO_CART, { orderItemId, quantityChange, trackedActionType: REFRESH_CART });
    } catch (e) {}
};

export const addToCart = (
    baseConfig,
    shipDate,
    history,
    trackCustomMetric,
    ctoProductInitial,
    ctoPrice,
    configuration,
    cartItems,
    configDetails,
    onAdd,
) => {
    if (!baseConfig) {
        console.error('Base config must be provided to add to cart');
        return;
    }
    let search;
    try {
        search = Helpers.getSearch(document.location.search);
    } catch (e) {}
    const {
        hasAccessories,
        catentryId,
        orderId,
        //if not in baseConfig default from the URL
        orderItemId = search.orderItemId,
        _dsku: derivedSku = '',
        path,
        recConfig1,
        recommendedConfigs,
        sku,
    } = baseConfig;
    const quantity = (cartItems || []).find(item => item.id === orderItemId)?.qty || 1;
    const { pick, skuPrice: skuPriceJSON, crossSellSkus } = getPicks(baseConfig);
    const configCatentryId = (getRecommendedConfig(recommendedConfigs) || {}).configCatentryId;
    return ETRApi.person
        .get()
        .then(person => {
            const { isGuest } = person || {};
            const guestResolver = isGuest ? ETRApi.person.setGuestIdentity() : Promise.resolve();

            return guestResolver.then(() => {
                return ETRApi.cto.addToCart(
                    {
                        picks: {
                            pick,
                        },
                        path,
                    },
                    {
                        skuPriceJSON,
                        derivedSku,
                    },
                    catentryId,
                    hasAccessories,
                    shipDate.date,
                    shipDate.leadTime,
                    recConfig1,
                    orderId,
                    orderItemId,
                    configCatentryId,
                    crossSellSkus,
                    quantity,
                    ctoPrice?.ctoConfiguration ? configDetails : null,
                );
            });
        })
        .then(resp => {
            const { addtocartconfig } = resp;
            if (addtocartconfig && !addtocartconfig.errorMessage) {
                const { redirectToURL } = addtocartconfig;

                conditionallyTrackCtoAddToCart(trackCustomMetric, addtocartconfig, quantity);
                if (onAdd) {
                    onAdd(resp);
                    return;
                }

                if (redirectToURL.indexOf('AccessoryAttachView') > -1 && history) {
                    //TODO: what happens when this doesn't come back?
                    redirectToURL && history.push(Helpers.getRelativePath(redirectToURL));
                } else {
                    //todo: could probably import the route checker and decide whether to use react-router
                    document.location.href = redirectToURL;
                }
            } else {
                //TODO: Not in the  comps where to show add to cart error
            }
        });
};

export default addToCart;
